<button (click)="isOpen = !isOpen" mat-icon-button cdkOverlayOrigin #trigger="cdkOverlayOrigin">
  <mat-icon>account_circle</mat-icon>
</button>

<!-- User Menu -->
<ng-template
  cdkConnectedOverlayHasBackdrop="true"
  cdkConnectedOverlayBackdropClass="no"
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
  (backdropClick)="isOpen = false"
>
  <div class="flex flex-col gap-3 mat-app-background mat-elevation-z6 px-3 pt-4 min-w-[250px] fade">
    <label class="font-medium text-xs text-secondary">ACCOUNT</label>

    <div class="flex gap-3 items-center">
      <mat-icon class="md">account_circle</mat-icon>
      <div>
        <h2 class="text-sm">{{ user$().username }}</h2>
        <h3 class="text-xs font-thin text-secondary">{{ user$().email }}</h3>
        <h3 class="text-xs text-secondary">{{ user$().role }}</h3>
      </div>
    </div>

    <mat-nav-list>
      <mat-divider></mat-divider>
      <a
        mat-list-item
        routerLinkActive="active"
        [routerLink]="['settings']"
        [routerLinkActiveOptions]="{ exact: true }"
        (click)="isOpen = false"
      >
        <mat-icon matListItemIcon>settings</mat-icon>
        <h3 matListItemTitle>Settings</h3>
      </a>
      <mat-divider></mat-divider>
      <a
        mat-list-item
        routerLinkActive="active"
        [routerLink]="['auth/login']"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <mat-icon matListItemIcon>logout</mat-icon>
        <h3 matListItemTitle>Logout</h3>
      </a>
    </mat-nav-list>
  </div>
</ng-template>
